/*global google*/
import React, { useState, useEffect } from 'react';
import AssignTargetPDMC from '../NewAdminPanel/AssignTarget/SelfAssignTargetPDMC';
import AssignTargetMNT from '../NewAdminPanel/AssignTarget/SelfAssignTargetMNT';
import AssignTargetOP from '../NewAdminPanel/AssignTarget/AssignTargetOP';
import AssignTargetOS from './AssignTarget/AssignTargetOS';



function SelfAssignTarget() {
    const [schemeCode, setSchemeCode] = useState(null);

    useEffect(() => {
        const schemeCode = sessionStorage.getItem("schemeCodeModel");
        setSchemeCode(schemeCode);
    }, []);
    
    const renderComponent = () => {
        switch (schemeCode) {
            case "1":
                return <AssignTargetPDMC />;
            case "14":
                return <AssignTargetPDMC />;
            case "5":
                return <AssignTargetPDMC />;
            case "16":
                return <AssignTargetMNT />;
            default:
                return <AssignTargetPDMC />;
        }
    };
    
    return (

        <>
            {renderComponent()}
        </>
    );
}

export default SelfAssignTarget;